// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import Asset, { AssetsImageProps } from "components/ui/Asset";
import React, { ReactElement, useCallback, useState } from "react";

import { startDemoMode } from "store/testrun";
import { useAppDispatch } from "store";

const DemoAsset: (props: AssetsImageProps) => ReactElement = props => {
  const [clickCount, setClickCount] = useState(0);
  const dispatch = useAppDispatch();

  const onClick = useCallback(() => {
    setClickCount(clickCount + 1);

    if (clickCount + 1 === 3) {
      dispatch(startDemoMode());
    }
  }, [clickCount, dispatch]);
  return (
    <span onClick={onClick}>
      <Asset {...props} />
    </span>
  );
};

export default DemoAsset;
